var map = {
	"./404.png": 6682,
	"./CheckList.svg": 9706,
	"./ali.png": 3870,
	"./banner3.png": 6547,
	"./banner4.png": 2940,
	"./callout.svg": 7094,
	"./discord_no_bg.png": 6518,
	"./favicon.svg": 3086,
	"./guideImg.png": 9737,
	"./hamburger.svg": 3631,
	"./hati.png": 188,
	"./icon-Home.svg": 6035,
	"./icon-Search.svg": 7250,
	"./icon-X.svg": 8470,
	"./icon-active-world.svg": 8575,
	"./icon-blog.svg": 1258,
	"./icon-chapter.svg": 9077,
	"./icon-copy.svg": 4313,
	"./icon-diagonal-arrow.svg": 2999,
	"./icon-down.svg": 5434,
	"./icon-drawer.svg": 7269,
	"./icon-infrean.svg": 4445,
	"./icon-insta.svg": 7783,
	"./icon-lock.svg": 4507,
	"./icon-medal.svg": 5519,
	"./icon-side-close-left.svg": 102,
	"./icon-up-arrow.svg": 3949,
	"./icon-world.svg": 5014,
	"./icon-youtube.svg": 5433,
	"./image 1.png": 5016,
	"./mura.png": 7905,
	"./rosy.png": 1217,
	"./subBanner-weniversity.png": 6850,
	"./weniv-api-logo-gray.svg": 3766,
	"./weniv-api-logo.svg": 6118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;